import React, { Component } from "react";
import "./style.scss";
import {
  NormalCheckbox,
  NormalInput,
  NormalButton,
  NormalModal,
  TableWrapper,
  NormalSelect,
} from "component/common";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getCommonApi,
  updateForm,
  commonUpdateApi,
  commonCreateApi,
  commonDeleteApi,
} from "redux/actions/common";
import { withTranslation } from "react-i18next";
import {
  NewPackageDtls,
  PackageItemDetails,
  updateCommon,
  PackageDtls,
  commonDeleteBackendApi,
  getBackendCommonApi,
} from "redux/actions/Backend";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { Toast } from "service/toast";

// Open Package
class SearchableDropdown extends Component {
  state = {
    isOpen: false,
    searchTerm: "",
    selectedItem: null,
  };

  componentDidMount() {
    let { stockName } = this.props;
    if (stockName) {
      this.setState({
        searchTerm: stockName,
      });
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.stockName !== this.props.stockName) {
      this.setState({ searchTerm: this.props.stockName });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };

  handleInputChange = (e) => {
    const { value } = e.target;
    this.setState({
      searchTerm: value,
      isOpen: true,
    });

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  handleItemSelect = (item) => {
    this.setState({
      selectedItem: item,
      searchTerm: item.stockName,
      isOpen: false,
    });

    if (this.props.onSelect) {
      this.props.onSelect(item);
    }
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  };

  getFilteredItems = () => {
    const { items } = this.props;
    const { searchTerm } = this.state;

    if (!searchTerm) return items;

    return items.filter(
      (item) =>
        item.stockName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.stockCode.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  render() {
    const { isOpen, searchTerm } = this.state;
    const { placeholder = "Search and select item...", items = [] } =
      this.props;
    const filteredItems = this.getFilteredItems();

    return (
      <div
        className="searchable-dropdown"
        ref={(ref) => (this.wrapperRef = ref)}
        style={{ position: "relative", width: "100%" }}
      >
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder={placeholder}
            value={searchTerm}
            onChange={this.handleInputChange}
            onFocus={() => this.setState({ isOpen: true })}
            style={{
              border: "1px solid #ddd",
              borderRadius: "4px",
              padding: "6px 10px",
              fontSize: "12px",
              height: "32px",
            }}
          />
        </div>

        {isOpen && (
          <div
            className="dropdown-menu show"
            style={{
              position: "absolute",
              top: "110%",
              width: "550px",
              left: 0,
              right: 0,
              zIndex: 9999,
              maxHeight: "750px",
              minHeight: "120px",
              overflowY: "auto",
              border: "1px solid #ddd",
              borderRadius: "4px",
              backgroundColor: "white",
              boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
            }}
          >
            {filteredItems.length > 0 ? (
              filteredItems.slice(0, 100).map((item, index) => (
                <button
                  key={item.stockCode}
                  className="dropdown-item"
                  onClick={() => this.handleItemSelect(item)}
                  style={{
                    display: "block",
                    width: "100%",
                    padding: "6px 10px",
                    border: "none",
                    backgroundColor: "transparent",
                    textAlign: "left",
                    cursor: "pointer",
                    fontSize: "12px",
                    lineHeight: "1.3",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#f8f9fa")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "transparent")
                  }
                >
                  <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                    {item.stockName}
                  </div>
                  <small style={{ color: "#666", fontSize: "10px" }}>
                    Code: {item.stockCode} | Price: ${item.item_Price}
                  </small>
                </button>
              ))
            ) : (
              <div
                className="dropdown-item-text"
                style={{ padding: "6px 10px", fontSize: "12px" }}
              >
                No items found
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export class OpenPackageClass extends Component {
  state = {
    cartPackageList: [
      {
        selectedItem: null,
        qty: 1,
        lineValue: 0,
        originalPrice: 0,
      },
    ],
    auto_deposit: "",
    auto_deposit_new: "",
    deposit: "",
    net_deposit: "",
    packageName: "",
    isOpenTreatmentDone: false,
    isOpenHoldQty: false,
    selectedProductData: "",
    TransactionHeader: [
      { label: "Item Name", width: "550px" },
      {
        label: "Qty",
        width: "20px",
        divClass: "justify-content-center ",
      },
      {
        label: "Unit Price",
        width: "40px",
        divClass: "justify-content-center",
      },
      {
        label: "Selling Price",
        width: "40px",
        divClass: "justify-content-start ml-2",
      },
      { label: "Action", width: "20px" },
    ],
    selectedData: "",
    holdQty: null,
    holdReasonList: [],
    packageStocks: [],
    autoDepositEnabled: false,
    isLoading: false,
  };

  componentDidMount = () => {
    this.handleGetPackageStocks();

    // if (isOpenPackage) {
    //   Toast({
    //     type: "error",
    //     message:
    //       "Open Package added to cart already. This will update the same open package line",
    //   });
    //   this.packageDetailsvalue();
    //   this.setState({
    //     packageName: isOpenPackage?.item_name,
    //     auto_deposit_new: isOpenPackage?.price,
    //   });
    // }
  };

  handleDeletePackage = (cartPackage) => {
    const packagesWithId = cartPackage.filter((pkg) => pkg?.id);
    if (packagesWithId) {
      packagesWithId.forEach((pkg) => {
        this.props
          .commonDeleteBackendApi(`PackageDtls/${pkg.id}/`)
          .then((res) => {})
          .catch((err) => {
            console.error("Error deleting package:", pkg.id, err);
          });
      });
    }
  };
  handleDeleteCart = async (data) => {
    let isOpenPackage = this.props.cartData?.find(
      (list) => list.itemstatus === 133
    );
    if (isOpenPackage) {
      this.props
        .commonDeleteApi(`itemcart/${isOpenPackage.id}/`)
        .then((res) => {});
    }
  };

  packageDetailsvalue = async () => {
    let { cartPackageList } = this.state;
    let { originalPackage } = this.props;
    await this.props.PackageDtls().then((res) => {
      cartPackageList = [];
      for (let key of res) {
        if (key.packageCode == originalPackage.item_code) {
          if (key?.isactive) {
            cartPackageList.push({
              id: key.id,
              item_code: key.code,
              stockName: key.description,
              qty: key.qty,
              lineValue: key.unitPrice,
              originalPrice: key.ttlUprice,
              itemUom: key.uom,
            });
          }
        }
      }
      this.setState({
        cartPackageList,
      });
    });
  };

  handleGetPackageStocks = async () => {
    let { packageStocks } = this.state;
    try {
      // await this.props.PackageItemDetails().then((res) => {
      //   const uniqueRecords = {};
      //   const uniqueStocks = [];
      //   res.forEach((record) => {
      //     const uniqueKey = record.stockCode;
      //     if (!uniqueRecords[uniqueKey]) {
      //       uniqueRecords[uniqueKey] = true;
      //       uniqueStocks.push(record);
      //     }
      //   });
      //   this.setState({ packageStocks: uniqueStocks });
      // });

      await this.props
        .getBackendCommonApi(`packageitemdetailsshorts`)
        .then((res) => {
          // const uniqueRecords = {};
          // const uniqueStocks = [];
          // res.forEach((record) => {
          //   const uniqueKey = record.stockCode;
          //   if (!uniqueRecords[uniqueKey]) {
          //     uniqueRecords[uniqueKey] = true;
          //     uniqueStocks.push(record);
          //   }
          // });
          this.setState({ packageStocks: res });
        });
    } catch (err) {
      console.log(err, "Error");
    }
  };

  handleCancel = () => {
    this.props.handleModal();
  };

  handleConfirm = () => {
    let { packageName, auto_deposit_new, cartPackageList, net_deposit } =
      this.state;
    let { originalPackage, tokenDetails } = this.props;
    let isOpenPackage = this.props.cartData?.filter(
      (list) => list.itemstatus === 133
    );

    let itemCode = Number(originalPackage?.item_code) + isOpenPackage?.length;
    if (packageName == "") {
      Toast({
        type: "error",
        message: "Please enter Package name",
      });
      return;
    }
    // this.handleDeletePackage(cartPackageList);
    // this.handleDeleteCart();
    // if (
    //   auto_deposit_new !== "" &&
    //   Number(auto_deposit_new) !== Number(net_deposit)
    // ) {
    //   Toast({
    //     type: "error",
    //     message: "Content total and package amount doesn't match",
    //   });
    //   return;
    // }
    this.setState({
      isLoading: true,
    });
    let packageHdrsPayload = {
      description: packageName,
      price: Number(net_deposit),
      unit_price: Number(net_deposit),
    };

    this.props
      .updateCommon(
        `PackageHdrs/update?where=${encodeURIComponent(
          JSON.stringify({ code: itemCode })
        )}`,
        packageHdrsPayload
      )

      .then((data) => {
        let body = {
          isactive: false,
        };
        this.props
          .updateCommon(
            `PackageDtls/update?where=${encodeURIComponent(
              JSON.stringify({ packageCode: itemCode })
            )}`,
            body
          )
          .then((data) => {
            let newPackageDtl = [];
            cartPackageList.map((x, index) => {
              let newdtails = {
                code: `${x.stockCode}0000`,
                description: x.stockName,
                cost: null,
                packageCode: itemCode,
                qty: Number(x.qty),
                uom: x.itemUom,
                itemDiv: null,
                packageBarcode: null,
                discPercent: null,
                price: Number(x.lineValue.toFixed(4)),
                discount: Number(x.discount.toFixed(4)),
                unitPrice: Number(x.lineValue.toFixed(4)),
                ttlUprice: Number(x.originalPrice.toFixed(4)),
                siteCode: tokenDetails.controlsite,
                lineNo: index + 1,
                serviceExpireActive: false,
                serviceExpireMonth: 0,
                treatmentLimitActive: false,
                treatmentLimitCount: 0,
                limitserviceFlexionly: false,
                isactive: true,
              };

              newPackageDtl.push(newdtails);
            });
            if (newPackageDtl.length > 0) {
              this.finalpackagelist(newPackageDtl, itemCode);
            }
          })
          .catch((err) => {
            this.setState({
              isLoading: false,
            });
          });
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
        });
      });
  };

  finalpackagelist = async (newitem, itemCode) => {
    let { originalPackage } = this.props;
    await this.props
      .NewPackageDtls(newitem)
      .then((res) => {
        let data = {
          ...originalPackage,
          packageCode: itemCode,
          item_price: this.state.net_deposit,
          itemstatus: 133,
        };
        this.setState({
          isLoading: false,
        });
        this.props.handleAddCart(
          data,
          null,
          null,
          null,
          null,
          null,
          null,
          true
        );
      })
      .catch((err) => {
        this.setState({
          isLoading: false,
        });
      });
  };

  handleInputChange = async ({ target: { name, value } }) => {
    await this.setState({
      [name]: value,
    });
    if (name === "auto_deposit_new" && this.state.autoDepositEnabled) {
      this.redistributeDeposit();
    }
  };

  // Handle auto deposit checkbox
  handleAutoDepositChange = (val) => {
    console.log(val, "val");
    const checked = typeof val === "boolean" ? val : val?.target?.value;
    console.log(checked, "checked");
    this.setState({ autoDepositEnabled: checked }, () => {
      if (checked) {
        this.redistributeDeposit();
      }
    });
  };

  // Redistribute deposit based on line value weightage
  // redistributeDeposit = () => {
  //   const { cartPackageList, auto_deposit_new } = this.state;
  //   const totalDeposit = parseFloat(auto_deposit_new) || 0;

  //   if (totalDeposit <= 0 || cartPackageList.length === 0) return;

  //   const totalOriginalPrice = cartPackageList.reduce((total, item) => {
  //     return total + (parseFloat(item.originalPrice) || 0);
  //   }, 0);

  //   if (totalOriginalPrice <= 0) return;

  //   const updatedList = cartPackageList.map((item) => {
  //     const previousOriginalPrice = parseFloat(item.originalPrice) || 0;
  //     const weightage = previousOriginalPrice / totalOriginalPrice;
  //     const allocatedAmount = totalDeposit * weightage;
  //     const qty = item.qty || 1;
  //     const price = allocatedAmount / qty;
  //     const discount = (parseFloat(item.lineValue) || 0) - price;

  //     return {
  //       ...item,
  //       originalPrice: Number(allocatedAmount).toFixed(2),
  //       price: price,
  //       discount: discount
  //     };
  //   });

  //   this.setState({ cartPackageList: updatedList }, this.calculateNetTotal);
  // };
  redistributeDeposit = () => {
    const { cartPackageList, auto_deposit_new } = this.state;
    const totalDeposit = Math.floor(parseFloat(auto_deposit_new)) || 0;

    if (totalDeposit <= 0 || cartPackageList.length === 0) return;

    const totalOriginalPrice = cartPackageList.reduce((total, item) => {
      return total + (parseFloat(item.originalPrice) || 0);
    }, 0);

    if (totalOriginalPrice <= 0) return;

    let remainingDeposit = totalDeposit;

    const updatedList = cartPackageList.map((item, index) => {
      const originalPrice = parseFloat(item.originalPrice) || 0;
      const weightage = originalPrice / totalOriginalPrice;
      let allocatedAmount = Math.floor(totalDeposit * weightage);

      if (index === 0) {
        // First item gets the leftover (rounded up share)
        const remainingItems = cartPackageList.length - 1;
        let totalAllocatedToOthers = 0;

        for (let i = 1; i < cartPackageList.length; i++) {
          const otherPrice = parseFloat(cartPackageList[i].originalPrice) || 0;
          const otherWeight = otherPrice / totalOriginalPrice;
          totalAllocatedToOthers += Math.floor(totalDeposit * otherWeight);
        }

        allocatedAmount = totalDeposit - totalAllocatedToOthers;
      }

      if (allocatedAmount > remainingDeposit) {
        allocatedAmount = remainingDeposit;
      }

      remainingDeposit -= allocatedAmount;

      const qty = item.qty || 1;
      const price = Math.floor(allocatedAmount / qty);
      const lineValue = allocatedAmount / qty;
      const discount = lineValue - price;

      return {
        ...item,
        originalPrice: allocatedAmount.toString(),
        price: price.toString(),
        lineValue: lineValue.toFixed(2),
        discount: Math.floor(discount).toString(),
      };
    });

    this.setState({ cartPackageList: updatedList }, this.calculateNetTotal);
  };

  // Handle item selection in dropdown
  handleItemSelect = (index, selectedItem) => {
    const { cartPackageList } = this.state;
    const updatedList = [...cartPackageList];
    const qty = updatedList[index].qty || 1;
    const originalPrice = parseFloat(selectedItem.item_Price) || 0;
    const lineValue = qty * originalPrice;
    const price = originalPrice / qty;
    const discount = lineValue - price;
    updatedList[index] = {
      ...updatedList[index],
      itemUom: selectedItem?.itemUom,
      stockCode: selectedItem?.stockCode,
      stockName: selectedItem?.stockName,
      selectedItem,
      originalPrice,
      lineValue,
      price,
      discount,
    };

    this.setState({ cartPackageList: updatedList }, () => {
      this.calculateNetTotal();
      // If auto deposit is enabled, redistribute after item selection
      if (this.state.autoDepositEnabled) {
        this.redistributeDeposit();
      }
    });
  };

  // Handle quantity change - now calculates original price based on line value
  handleQtyChange = (index, qty) => {
    const { cartPackageList, autoDepositEnabled } = this.state;
    const updatedList = [...cartPackageList];
    const qtyValue = parseInt(qty) || 1;
    const lineValue = parseFloat(updatedList[index].lineValue) || 0;
    const originalPrice = qtyValue * lineValue;
    const price = originalPrice / qtyValue;
    const discount = lineValue - price;

    updatedList[index] = {
      ...updatedList[index],
      qty: qtyValue,
      originalPrice,
      price,
      discount,
    };

    this.setState({ cartPackageList: updatedList }, () => {
      this.calculateNetTotal();
      if (autoDepositEnabled) {
        this.redistributeDeposit();
      }
    });
  };

  // Handle line value change - now calculates original price based on quantity
  handleLineValueChange = (index, lineValue) => {
    const { cartPackageList, autoDepositEnabled } = this.state;
    if (autoDepositEnabled) return;

    const updatedList = [...cartPackageList];
    const lineValueFloat = parseFloat(lineValue) || 0;
    const qty = updatedList[index].qty || 1;
    const originalPrice = +(qty * lineValueFloat).toFixed(4);
    const price = +(originalPrice / qty).toFixed(4);
    const discount = +(lineValueFloat - price).toFixed(4);

    updatedList[index] = {
      ...updatedList[index],
      lineValue: +lineValueFloat.toFixed(4),
      originalPrice,
      price,
      discount,
    };

    this.setState({ cartPackageList: updatedList }, this.calculateNetTotal);
  };

  // Handle original price change - now calculates line value based on quantity
  handleOriginalPriceChange = (index, originalPrice) => {
    const { cartPackageList, autoDepositEnabled } = this.state;
    if (autoDepositEnabled) return;

    const updatedList = [...cartPackageList];
    const priceValue = parseFloat(originalPrice) || 0;
    const qty = updatedList[index].qty || 1;
    const lineValue = +(qty * priceValue).toFixed(4);
    const price = +(priceValue / qty).toFixed(4);
    const discount = +(lineValue - price).toFixed(4);

    updatedList[index] = {
      ...updatedList[index],
      originalPrice: +priceValue.toFixed(4),
      lineValue: price,
      price,
      discount,
    };

    this.setState({ cartPackageList: updatedList }, this.calculateNetTotal);
  };

  // Add new row
  handleAddRow = () => {
    const { cartPackageList } = this.state;
    const newRow = {
      selectedItem: null,
      qty: 1,
      lineValue: 0,
      originalPrice: 0,
    };

    this.setState({
      cartPackageList: [...cartPackageList, newRow],
    });
  };

  // Delete row
  handleDeleteRow = (index) => {
    const { cartPackageList, autoDepositEnabled } = this.state;
    if (cartPackageList.length > 1) {
      const updatedList = cartPackageList.filter((_, i) => i !== index);
      this.setState({ cartPackageList: updatedList }, () => {
        this.calculateNetTotal();
        // If auto deposit is enabled, redistribute after deletion
        if (autoDepositEnabled) {
          this.redistributeDeposit();
        }
      });
    }
  };

  // Calculate net total
  calculateNetTotal = () => {
    const { cartPackageList } = this.state;
    const netTotal = cartPackageList.reduce((total, item) => {
      return total + (parseFloat(item.originalPrice) || 0);
    }, 0);

    this.setState({ net_deposit: netTotal.toFixed(2) });
  };

  render() {
    let {
      cartPackageList,
      auto_deposit_new,
      net_deposit,
      TransactionHeader,
      packageName,
      packageStocks,
      autoDepositEnabled,
      isLoading,
    } = this.state;
    let { t } = this.props;

    return (
      <>
        <div className="row new-cart treatment-done">
          <div className="col-12">
            <h5 className="fs-18 font-700 mb-3 title">
              {t("Open Package Editor")}
            </h5>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-md-10 mt-2">
                <NormalInput
                  value={packageName}
                  name="packageName"
                  placeholder="Package Name"
                  className=" w-100 h-100 "
                  style={{ fontSize: "14px", height: "40px" }}
                  onChange={this.handleInputChange}
                />
              </div>
              <div className="col-md-2"></div>
              {/* <div className="col-md-3 mt-2">
                <div className="d-flex align-items-center justify-content-end">
                  <label className="ml-2 mr-3" style={{ fontSize: "14px" }}>
                    Auto Amount
                  </label>
                  <NormalCheckbox
                    checked={autoDepositEnabled}
                    onChange={(checked) =>
                      this.handleAutoDepositChange(checked)
                    }
                  />
                </div>
              </div>

              <div className="col-md-2">
                <NormalInput
                  value={auto_deposit_new}
                  name="auto_deposit_new"
                  placeholder="Amount"
                  className=" w-100 h-100 text-right"
                  style={{ fontSize: "14px", height: "40px" }}
                  onChange={this.handleInputChange}
                  disabled={autoDepositEnabled}
                />
              </div> */}
              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="col-12 mt-3" style={{ minHeight: "750px" }}>
            <TableWrapper
              className="mb-3 h-100"
              headerDetails={TransactionHeader}
            >
              {cartPackageList && cartPackageList.length > 0 ? (
                cartPackageList.map((cartPackage, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className="text-left">
                          <SearchableDropdown
                            items={packageStocks}
                            stockName={cartPackage?.stockName}
                            placeholder="Search and select item..."
                            onSelect={(item) =>
                              this.handleItemSelect(index, item)
                            }
                          />
                        </div>
                      </td>
                      <td
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div className="text-right" style={{ width: "60px" }}>
                          <NormalInput
                            type="number"
                            value={cartPackage.qty}
                            min="1"
                            className="text-right w-100"
                            style={{
                              fontSize: "12px",
                              height: "32px",
                              width: "100%",
                            }}
                            onChange={(e) =>
                              this.handleQtyChange(index, e.target.value)
                            }
                          />
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="text-center" style={{ width: "100px" }}>
                          <NormalInput
                            type="number"
                            value={cartPackage.lineValue}
                            step="0.01"
                            className="text-right w-100"
                            disabled={autoDepositEnabled}
                            style={{
                              fontSize: "12px",
                              height: "32px",
                              width: "100%",
                              backgroundColor: autoDepositEnabled
                                ? "#f8f9fa"
                                : "white",
                            }}
                            onChange={(e) =>
                              this.handleLineValueChange(index, e.target.value)
                            }
                          />
                        </div>
                      </td>
                      <td className="text-right">
                        <div className="text-right" style={{ width: "100px" }}>
                          <NormalInput
                            type="number"
                            value={cartPackage.originalPrice}
                            step="0.01"
                            className="text-right w-100"
                            disabled={autoDepositEnabled}
                            style={{
                              fontSize: "12px",
                              height: "32px",
                              width: "100%",
                              backgroundColor: autoDepositEnabled
                                ? "#f8f9fa"
                                : "white",
                            }}
                            onChange={(e) =>
                              this.handleOriginalPriceChange(
                                index,
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center align-items-center">
                          <button
                            type="button"
                            className="btn btn-sm btn-success"
                            onClick={this.handleAddRow}
                            title="Add Row"
                            style={{
                              marginRight: "5px",
                              padding: "4px 8px",
                              fontSize: "12px",
                              minWidth: "30px",
                              height: "28px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <AiOutlinePlus />
                          </button>
                          {cartPackageList.length > 1 && (
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => this.handleDeleteRow(index)}
                              title="Delete Row"
                              style={{
                                padding: "4px 8px",
                                fontSize: "12px",
                                minWidth: "30px",
                                height: "28px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <AiOutlineMinus />
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5">
                    <div className="d-flex align-items-center justify-content-center">
                      {t("No Data")}
                    </div>
                  </td>
                </tr>
              )}

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <div className="text-right">
                    <div className="text-center fw-700">{t("Net Total")}</div>
                    <div className="fw-700">
                      <NormalInput
                        value={net_deposit}
                        disabled={true}
                        className="text-right w-70"
                        style={{ fontSize: "12px", height: "32px" }}
                      />
                    </div>
                  </div>
                </td>
                <td></td>
              </tr>
            </TableWrapper>
          </div>

          <div className="col-12 mt-3">
            <div className="d-flex flex-wrap justify-content-end my-2">
              <div className="col-md-2 col-6">
                <NormalButton
                  buttonClass={"treatment"}
                  resetbg={true}
                  className="col-12 fs-15 "
                  label="Cancel"
                  onClick={() => this.handleCancel()}
                />
              </div>
              {isLoading ? (
                <div class="d-flex align-items-center justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">{t("Loading...")}</span>
                  </div>
                </div>
              ) : (
                <div className="col-md-2 col-6">
                  <NormalButton
                    submitBtn={true}
                    className="col-12 fs-15 "
                    label="Confirm"
                    onClick={() => this.handleConfirm()}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  selected_cstomer: state.common.selected_cstomer,
  basicApptDetail: state.appointment.basicApptDetail,
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      updateForm,
      commonUpdateApi,
      commonCreateApi,
      PackageItemDetails,
      updateCommon,
      NewPackageDtls,
      PackageDtls,
      commonDeleteBackendApi,
      commonDeleteApi,
      getBackendCommonApi,
    },
    dispatch
  );
};

export const OpenPackage = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(OpenPackageClass)
);